import { useTranslation } from 'react-i18next';
import { WITHDRAWAL_TRANSLATION } from '../constants/common';
import { useUserFieldsValidation } from '@/modules/shared/hooks/useUserFieldsValidation';
import { createWithdrawalSchema } from '../constants/validation';
import { ObjectSchema } from 'yup';

export const useWithdrawalValidation = (
  typeOfRequestOptions: any,
  hrnSampleStatusOptions: any,
  paperConsentOptions: any,
): ObjectSchema<any> => {
  const { t } = useTranslation(WITHDRAWAL_TRANSLATION);
  const {
    firstName: participantFirstName,
    lastName: participantLastName,
    email: participantEmail,
  } = useUserFieldsValidation();

  const schema = createWithdrawalSchema({
    t,
    participantFirstName,
    participantLastName,
    participantEmail,
    typeOfRequestOptions,
    hrnSampleStatusOptions,
    paperConsentOptions,
  });

  return schema;
};
